export * from "./AdminDoctorDetails.async";
